var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6824e91e-c9de-4782-9c23-e54ed80d53d2",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540,861.79c-218.03,0-421.73-117.7-531.49-307.11l-8.51-14.68,8.51-14.68C118.27,335.91,321.97,218.21,540,218.21s421.78,117.7,531.49,307.11l8.51,14.68-8.51,14.68c-109.7,189.41-313.4,307.11-531.49,307.11ZM67.94,540c101.19,162.84,280.48,263.29,472.06,263.29s370.93-100.45,472.06-263.29c-101.13-162.84-280.43-263.29-472.06-263.29s-370.88,100.45-472.06,263.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M540,744.04c-112.5,0-204.04-91.53-204.04-204.04s91.53-204.04,204.04-204.04,204.04,91.53,204.04,204.04-91.53,204.04-204.04,204.04ZM540,394.47c-80.22,0-145.53,65.31-145.53,145.53s65.31,145.53,145.53,145.53,145.53-65.31,145.53-145.53-65.31-145.53-145.53-145.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeIcon);
export default __webpack_public_path__ + "static/media/SeeIcon.cd18fee8364e146321a81101d031f9af.svg";
export { ForwardRef as ReactComponent };